import clsx from 'clsx';
import CustomLink from 'components/Common/CustomLink/CustomLink';
import TooltipComponent from 'components/Common/TooltipComponent/TooltipComponent';
import { useMergedStyles } from 'hooks/useMergedStyles';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { Styles } from 'types/styles';

import styles from './DashboardPageWrapperNavigationLink.module.scss';

type Props = {
  newStyles?: Styles;
  route: string;
  iconClass: string;
  Icon: FC<{ color?: string }>;
  label?: string;
  iconSide?: 'left' | 'right';
  isActive?: boolean;
  targetBlank?: boolean;
};

const DashboardPageWrapperNavigationLink: FC<Props> = ({
  newStyles = {},
  route,
  Icon,
  label = '',
  iconSide = 'left',
  iconClass,
  isActive,
  targetBlank,
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);
  const { t } = useTranslation('dashboard');

  return (
    <div
      className={clsx(mergedStyles['dashboard-page-wrapper-navigation-link-wrapper'], {
        [mergedStyles.active]: isActive,
      })}
    >
      <CustomLink
        targetBlank={targetBlank}
        linkProps={{ href: route }}
        className={clsx(mergedStyles['dashboard-page-wrapper-navigation-link'], {
          [mergedStyles.active]: isActive,
        })}
      >
        <div
          className={clsx(
            mergedStyles['dashboard-page-wrapper-navigation-link-icon-wrapper'],
            mergedStyles[iconClass],
            {
              [mergedStyles.rightSide]: iconSide === 'right',
            },
          )}
        >
          <TooltipComponent
            newStyles={mergedStyles}
            title={t(label)}
            position="right"
            theme="no-arrow default"
            className={mergedStyles['navigation-link-tooltip']}
          >
            <div
              className={clsx(mergedStyles['icon-wrapper'], {
                [mergedStyles.active]: isActive,
              })}
            >
              <Icon />
            </div>
          </TooltipComponent>
        </div>
      </CustomLink>
    </div>
  );
};

export default DashboardPageWrapperNavigationLink;
